import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { fetchSearchArtworks } from '../store/actions/artwork'

function Navbar(props) {

  const [searchQuery, setSearchQuery] = useState('')
  const history = useHistory()
  const dispatch = useDispatch()

  function handleSubmitSearch(e) {
    e.preventDefault()
    dispatch(fetchSearchArtworks(searchQuery))
    history.push('/', {
      fromSearch: true
    })
  }

  function handleChangeSearch(e) {
    setSearchQuery(e.target.value)
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-warning">
      <div className="container">
      <p className="navbar-brand mb-0">The Artworks Gallery</p>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <Link className="nav-link active" to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link active" to="/favorites">Favorites</Link>
          </li>
        </ul>
        <form className="d-flex" onSubmit={handleSubmitSearch}>
          <input className="form-control me-2" type="search" onChange={handleChangeSearch}></input>
          <button className="btn btn-outline-success" type="submit">Search</button>
        </form>
      </div>
      </div>
    </nav>
  )
}

export default Navbar